<div class="fixed-width-container" [style.maxWidth.px]="width">
  <ng-content></ng-content>
</div>
